export default function NewsDetailSkeleton() {
  return (
    <div className="py-4 pb-8 lg:pb-16 animate-pulse">
      {/* Back Button */}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
        {/* MAIN CONTENT */}
        <div className="col-span-12">
          {/* Banner */}
          <div className="w-full aspect-[16/9] bg-gray-200 rounded-2xl" />

          {/* Title */}
          <div className="h-7 my-5 bg-gray-200 rounded w-3/4" />

          {/* Content paragraphs */}
          <div className="space-y-3">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-11/12" />
            <div className="h-4 bg-gray-200 rounded w-10/12" />
            <div className="h-4 bg-gray-200 rounded w-9/12" />
          </div>
        </div>
      </div>
    </div>
  );
}
